import { render, staticRenderFns } from "./layout-main-inner.vue?vue&type=template&id=0bd6c146&scoped=true&"
import script from "./layout-main-inner.vue?vue&type=script&lang=js&"
export * from "./layout-main-inner.vue?vue&type=script&lang=js&"
import style0 from "./layout-main-inner.vue?vue&type=style&index=0&id=0bd6c146&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd6c146",
  null
  
)

export default component.exports